import { PropsWithChildren } from 'react'
import styled, { css } from 'styled-components'

export type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> &
  PropsWithChildren<{
    cta?: boolean
  }>

const Button = styled.button.attrs<ButtonProps>(({ cta }) => ({
  className: ['button button--solid', cta && 'button--cta'].filter((x) => !!x).join(' ')
}))<ButtonProps>`
  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.3;
        `
      : ''}
`

export default Button
